import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class CustomerPaymentForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      name: [ '', Validators.required ],
      moneybirdContactId: [ '', Validators.required ],
    });
  }
}
